<div class="topDiv" [style.background-color]="backgroundColorScreen" style="padding: 5px;">
    <div  style="padding: 10px;
    border-radius: 5px; margin-bottom: 10px;margin-top: 4%;">
        <div class="agGridOuterDiv" style="margin: 0;width: 100%;margin-bottom: 3%;"> 
            <mat-toolbar class="mat-toolbar page-header mat-toolbar-single-row">
                <!-- <div class="title-inner-wrapper">
                   <p style="color: #6e6e6e;margin: 0;">Dashboard</p> 
                </div> -->
                <div class="left-section">
                    <span class="title" style="margin: 0;">Dashboard</span>
                
                    <nav class="filters">
                      <span
                        *ngFor="let item of filterOptions"
                        (click)="selectFilter(item)"
                        [class.active]="selectedFilter === item"
                      >
                        {{ item }}
                      </span>
                    </nav>
                  </div>
                  <span class="spacer"></span> 
                  <div class="right-section">
                    <mat-form-field appearance="outline" class="date-range-field">
                        <mat-label>Date Range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                          <input matStartDate [(ngModel)]="rangeStartDate" (dateChange)="onDateRangeChange()" placeholder="Start date" readonly>
                          <input matEndDate [(ngModel)]="rangeEndDate" (dateChange)="onDateRangeChange()" placeholder="End date" readonly>
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                      
                      <mat-form-field class="filter" appearance="outline">
                        <mat-label i18n="@@targetloginusername">
                            Select Activity
                        </mat-label>
                        <mat-select [(ngModel)]="selectedActivity" name="activity" (selectionChange)="onActivityChanged($event)">
                                <mat-option *ngFor="let activity of activityOptions" [value]="activity">
                                    {{activity}}
                                </mat-option>
                        </mat-select>
                    </mat-form-field>
                  </div>
            </mat-toolbar>

            <div class="row" style="margin-top: 2%;">
                <div class="col-8">
                    <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                    [columnDefs]="columnDefs"  [animateRows]="true"
                    [defaultColDef]="defaultColDef" [rowHeight]="35"
                    [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                    [components]="components"
                    [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                    (paginationChanged)="onPaginationChanged()"
                    (gridReady)="onGridReady($event)" [hidden]="!true" style="height: 55vh;">
                </ag-grid-angular>
                </div>
                <div class="col-4">
                    <div style="height: 55vh;background: #fff;padding: 3%;">
                        <canvas id="doughnutChartId" style="margin: auto;">{{doughnutChart}}</canvas>
                    </div>
                   
                </div>
            </div>
            <div class="row" style="margin-top: 2%;">
                <div class="col-12">
                    <div style="height: 55vh;background: #fff;padding: 3%;">
                        <canvas id="barchartId" style="width: 100%; height: 100%;">{{barChart}}</canvas>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 2%;">
                <div class="col-12">
                    <div style="height: 55vh;background: #fff;padding: 3%;">
                        <canvas id="lineChartId" style="width: 100%; height: 100%;">{{lineChart}}</canvas>
                    </div>
                </div>
            </div>
            </div>
    </div>
    
</div>